export enum InfoIconUrl {
  // Access group
  ACCESS_GROUP = '/help/access-groups',
  ACCESS_GROUPS_DIRECTORY = ACCESS_GROUP + '/access-group-search-view',
  ACCESS_GROUPS_DETAILS = ACCESS_GROUP + '/access-group-detail-view',

  // Business log
  BUSINESS_LOG = '/help/business-log',
  BUSINESS_LOG_DIRECTORY = BUSINESS_LOG + '/business-log-view',

  // Classifiers
  CLASSIFIERS = '/help/classifiers',
  CLASSIFIER_DIRECTORY = CLASSIFIERS + '/classifier-search-view',
  CLASSIFIER_DETAIL = CLASSIFIERS + '/classifier-detail-view',

  // Classifier mappings
  CLASSIFIER_MAPPINGS = '/help/classifier-mappings',
  CLASSIFIER_MAPPING_DIRECTORY = CLASSIFIER_MAPPINGS +
    '/classifier-mappings-search-view',
  CLASSIFIER_MAPPING_DETAIL = CLASSIFIER_MAPPINGS +
    '/classifier-mappings-detail-view',

  // Dashboard
  DASHBOARD = '/help/dashboard',
  USER_CALENDAR = DASHBOARD + '/user-calendar-view',
  USER_BOOKMARKS = DASHBOARD + '/user-bookmarks-view',
  LAST_CALCULATIONS = DASHBOARD + '/last-calculations-view',
  LAST_TRANSFER_SUBJECTS = DASHBOARD + '/last-transfer-subjects-view',
  WAITING_STATUSES = DASHBOARD + '/waiting-statuses-view',
  SUSPENDED_LOADINGS = DASHBOARD + '/suspended-loadings-view',
  CURRENT_NEXT_LOAD_CALC = DASHBOARD + '/current-next-load-calc-view',
  INPUT_COLLECTION = DASHBOARD + '/input-collection-view',
  LATEST_COMMENTS = DASHBOARD + '/latest-comments-view',

  // Dashboard settings
  DASHBOARD_SETTINGS = '/help/dashboard-settings',
  USER_BOOKMARKS_SETTINGS = DASHBOARD_SETTINGS +
    '/user-dashboard-settings-bookmarks-view',
  USER_DASHBOARD_SETTINGS = DASHBOARD_SETTINGS +
    '/user-dashboard-settings-view',
  USER_DASHBOARD_CALENDAR_SETTINGS = DASHBOARD_SETTINGS +
    '/user-dashboard-settings-calendar-view',
  USER_FOLLOWED_DATA_OBJECT_GROUP = DASHBOARD_SETTINGS +
    '/user-followed-data-object-group-view',
  USER_FOLLOWED_DATA_SUBJECT = DASHBOARD_SETTINGS +
    '/user-followed-data-subject-view',

  // Data object descriptions
  DATA_OBJECT_DESCRIPTIONS = '/help/data-object-descriptions',
  INPUT_DATA_OBJECT_DESCRIPTIONS_DIRECTORY = DATA_OBJECT_DESCRIPTIONS +
    '/input-data-object-description-search-view',
  INPUT_DATA_OBJECT_DESCRIPTIONS_DETAILS = DATA_OBJECT_DESCRIPTIONS +
    '/input-data-object-description-detail-view',
  OUTPUT_DATA_OBJECT_DESCRIPTIONS_DIRECTORY = DATA_OBJECT_DESCRIPTIONS +
    '/output-data-object-description-search-view',
  OUTPUT_DATA_OBJECT_DESCRIPTIONS_DETAILS = DATA_OBJECT_DESCRIPTIONS +
    '/output-data-object-description-detail-view',

  // Data object groups
  DATA_OBJECT_GROUPS = '/help/data-object-groups',
  DATA_OBJECT_GROUP_DIRECTORY = DATA_OBJECT_GROUPS +
    '/data-object-group-search-view',
  DATA_OBJECT_GROUP_DETAILS = DATA_OBJECT_GROUPS +
    '/data-object-group-detail-view',

  // Data subjects
  DATA_SUBJECTS = '/help/data-subjects',
  DATA_SUBJECT_DIRECTORY = DATA_SUBJECTS + '/data-subject-search-view',
  DATA_SUBJECT_DETAILS = DATA_SUBJECTS + '/data-subject-detail-view',

  // Input data
  INPUT_DATA = '/help/input-data',
  INPUT_DATA_DIRECTORY = INPUT_DATA + '/input-data-processing-state-view',
  INPUT_DATA_PROCESSING_EVENTS_DIRECTORY = INPUT_DATA +
    '/input-data-errors-view',
  INPUT_DATA_DETAIL = INPUT_DATA + '/input-data-subjects-view',
  INPUT_DATA_SUBJECT_DETAIL = INPUT_DATA + '/input-data-subject-view',

  // Output data
  OUTPUT_DATA = '/help/output-data',
  OUTPUT_DATA_DIRECTORY = OUTPUT_DATA + '/output-data-processing-state-view',
  OUTPUT_DATA_PROCESSING_EVENTS_DIRECTORY = OUTPUT_DATA +
    '/output-data-errors-view',

  // Relations
  RELATIONS = '/help/relations',
  RELATIONS_DIRECTORY = RELATIONS + '/relation-view',

  // Roles
  ROLES = '/help/roles',
  ROLE_DIRECTORY = ROLES + '/role-search-view',
  ROLE_DETAILS = ROLES + '/role-detail-view',

  // Sample
  SAMPLE = '/help/sample',
  SAMPLE_DIRECTORY = SAMPLE + '/sample-search-view',
  SAMPLE_DETAILS = SAMPLE + '/sample-detail-view',

  // System classifiers
  SYSTEM_CLASSIFIERS = '/help/system-classifiers',
  SYSTEM_CLASSIFIER_DIRECTORY = SYSTEM_CLASSIFIERS +
    '/system-classifier-search-view',
  SYSTEM_CLASSIFIER_DETAILS = SYSTEM_CLASSIFIERS +
    '/system-classifier-detail-view',

  // User settings
  USER_SETTINGS = '/help/user-settings',
  TOKEN_DIRECTORY = USER_SETTINGS + '/user-token-view',

  // User
  USERS = '/help/users',
  USER_DIRECTORY = USERS + '/user-search-view',
  USER_DETAILS = USERS + '/user-detail-view',

  // Visual validation
  VISUAL_VALIDATION = '/help/visual-validation',
  VISUAL_VALIDATION_CROSS_TABLE = VISUAL_VALIDATION + '/cross-table-view',
  VISUAL_VALIDATION_TIME_SERIES = VISUAL_VALIDATION + '/time-series-view',
  VISUAL_VALIDATION_COMPARISON = VISUAL_VALIDATION + '/comparison-view',
  VISUAL_VALIDATION_TIME_SERIES_COMPARISON = VISUAL_VALIDATION +
    '/time-series-comparison-view',
  VISUAL_VALIDATION_REPORT = VISUAL_VALIDATION +
    '/input-data-error-report-view',
}
